'use client';

import { useApi } from '@prismo-io/core';
import useSWR from 'swr';
import { fetchExperiences } from '../../../utils/fetch-experiences';

export const useExperiencesSidebar = () => {
  const { client } = useApi();

  return useSWR('experience-quark-sidebar', async () => {
    const {
      data: { session },
    } = await client.auth.getSession();

    if (!session) {
      throw new Error('');
    }

    return fetchExperiences(client, session.user.id);
  });
};
